import Swagger from "./Swagger";

export default Swagger;
